<template>
    <div>
        <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" :colon="false" :form="form" @submit="handleSubmit">
            <a-row>
                <!--                <a-col :lg="12" :md="12" :sm="24">-->
                <!--                    <SelectField style="width: 90%; margin: 0.5rem auto" label="井类型" id="type" :disabled = "view === '修改检查井'"-->
                <!--                                 :modelValue="form.type" :options="wellTypes" required labelWidth="40%"-->
                <!--                                 @update:modelValue="(value) => handleModelValueUpdate('type', value)"-->
                <!--                    />-->
                <!--                </a-col>-->
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                                :modelValue="form.code" placeholder="请输入编号" required
                                @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                    />
                </a-col>
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="经度" type="text" id="x" :disabled = "view === '修改检查井'"
                                :modelValue="form.x" placeholder="请输入经度" inputImg required
                                @img-click="pasteLnglat"
                                @update:modelValue="(value) => handleModelValueUpdate('x', value)"
                    />
                </a-col>
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="纬度" type="text" id="y" :disabled = "view === '修改检查井'"
                                :modelValue="form.y" placeholder="请输入纬度" inputImg required
                                @img-click="pasteLnglat"
                                @update:modelValue="(value) => handleModelValueUpdate('y', value)"
                    />
                </a-col>
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="所在位置" type="text" id="location"
                                :modelValue="form.location" placeholder="请输入位置"
                                @update:modelValue="(value) => handleModelValueUpdate('location', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="井盖直径(m)" type="number" id="diameterCover"
                                :modelValue="form.diameterCover" placeholder="请输入井盖直径(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('diameterCover', value)"
                    />
                </a-col>
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="井室直径(m)" type="number" id="diameterRoom"
                                :modelValue="form.diameterRoom" placeholder="请输入井室直径(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('diameterRoom', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="地面高程(m)" type="number" id="elevation"
                                :modelValue="form.elevation" placeholder="请输入地面高程(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('elevation', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="井盖材质" type="text" id="materialCover"
                                :modelValue="form.materialCover" placeholder="请输入井盖材质"
                                @update:modelValue="(value) => handleModelValueUpdate('materialCover', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="检查井材质" type="text" id="materialWell"
                                :modelValue="form.materialWell" placeholder="请输入检查井材质"
                                @update:modelValue="(value) => handleModelValueUpdate('materialWell', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="井盖形状" type="text" id="shapeCover"
                                :modelValue="form.shapeCover" placeholder="请输入井盖形状"
                                @update:modelValue="(value) => handleModelValueUpdate('shapeCover', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="井深" type="number" id="depth"
                                :modelValue="form.depth" placeholder="请输入井深"
                                @update:modelValue="(value) => handleModelValueUpdate('depth', value)"
                    />
                </a-col>


            </a-row>

            <div class="center" style="margin-top: 1rem;">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField text="保存" primary @click="handleSubmit"/>
                </a-space>
            </div>
        </a-form>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { modifyRainWell,fetchDetail } from "../api/pipe-info.js";

export default {
    data() {
        return {
            view: '修改检查井',
            wellTypes: [],
            detail: {},
            form: {
                category: null,
                type: null,
                code: null,
                lnglat: null,
                location: null,
                diameterCover: null,
                diameterRoom: null,
                elevation: null,
                materialCover: null,
                materialWell: null,
                shapeCover: null,
                depth: null,
            },
            pipeList: [],
            saveLoading: false,
        };
    },
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    watch: {
        selectedWell: {
            handler() {
                if (this.view === "修改检查井" && this.selectedWell._edit) {
                    this.getDetail();
                }
            },
            deep: true,
        },
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        rainWellTypes() {
            return this.findDataDict("rainWellType");
        },
        sewageWellTypes() {
            return this.findDataDict("sewageWellType");
        },
    },

    mounted() {
        console.log("----id:", this.id);
        this.getDetail();
    },

    methods: {
        getDetail() {
            fetchDetail({ id: this.id, type: 'rain_well' }).then((res) => {
                if (!res || !res.id) {
                    this.$message.error('未找到检查井信息');
                    return;
                }
                console.log("res::", res);
                this.form = { ...this.form, ...res };
            }).catch((error) => {
                console.error("获取检查井信息失败", error);
                this.$message.error('获取检查井信息失败，请重试');
            });
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        pasteLnglat() {
            const { lng, lat } = this.selectedLnglat;
            if (!lng) {
                this.$message.error("请点击地图选择经纬度");
                return;
            }
            this.form.lnglat = lng + "," + lat
        },

        onCategoryChange(value) {
            this.form.type = undefined; // 重置 type 字段

            if (value === "sewage") {
                this.wellTypes = this.sewageWellTypes;
            } else {
                this.wellTypes = this.rainWellTypes;
            }
        },

        handleSubmit() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            if (!this.form.code) {
                this.$message.error('编号不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.x && !this.form.y) {
                this.$message.error('经纬度不能为空');
                this.isSubmitting = false;
                return;
            }

            this.saveLoading = true;
            modifyRainWell(this.form).then(() => {
                this.cancel();
            })
                .finally(() => {
                    this.saveLoading = false;
                });
        },

        cancel() {
            this.$emit('show-rain-well-index');
        },
    },
};
</script>

<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>
